import { render, staticRenderFns } from "./createAdmin.vue?vue&type=template&id=4a069b0c"
import script from "./createAdmin.vue?vue&type=script&lang=ts"
export * from "./createAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports